import { useMemo } from 'react'
import {
  savedChanges,
  savedIAMAccessKey,
  savedIAMAccessSecret,
  savedIAMPolicyArn,
  savedIAMUserGroup,
} from '../Info/storage'
import { TrackedTextField } from '../Info/TrackedInputs'

type Props = {
  iam_organization_usergroup: string
  iam_organization_policy_arn: string
  iam_organization_admin_accessKey: string
}

export function IamOrganization(props: Props) {
  const [changes] = savedChanges.useState([])

  const accessKeyIsChanged = useMemo(
    () => changes.includes('iam_organization_admin_accessKey'),
    [changes],
  )

  return (
    <>
      <TrackedTextField
        trimValue
        savedStorage={savedIAMUserGroup}
        label="user group"
        title="iam_organization_usergroup"
        initialValue={props.iam_organization_usergroup}
      />

      <TrackedTextField
        trimValue
        savedStorage={savedIAMPolicyArn}
        label="policy arn"
        title="iam_organization_policy_arn"
        initialValue={props.iam_organization_policy_arn}
      />

      <TrackedTextField
        trimValue
        savedStorage={savedIAMAccessKey}
        label="access key"
        title="iam_organization_admin_accessKey"
        initialValue={props.iam_organization_admin_accessKey}
      />

      {accessKeyIsChanged && (
        <TrackedTextField
          trimValue
          savedStorage={savedIAMAccessSecret}
          label="secret key"
          title="iam_organization_admin_accessSecret"
          initialValue=""
          type="password"
        />
      )}
    </>
  )
}
